import { Link } from 'react-router-dom'
import { MessageSquareText, PhoneCall, ArrowRight } from 'lucide-react'
import { KpiCard } from '@/components/ui/KpiCard'

export function Dashboard() {
  return (
    <div className="view-transition max-w-7xl mx-auto px-10 pt-8 pb-16">
      {/* Hero */}
      <div className="mb-10">
        <div className="flex items-center gap-2 mb-2">
          <span className="pulse-live" />
          <span className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">
            Sistema activo
          </span>
        </div>
        <h1 className="font-display text-6xl font-semibold text-navy-700 leading-none">
          Hola, Hernán 👋
        </h1>
        <p className="text-slate-600 mt-3 text-base max-w-xl">
          Resumen operativo de hoy. Elegí dónde entrar.
        </p>
      </div>

      {/* KPIs globales */}
      <div className="grid grid-cols-4 gap-4 mb-10">
        <KpiCard label="Cobrado hoy" value="$8,921" color="emerald" delta={{ value: '+18%', up: true }} />
        <KpiCard label="Clientes activos" value="847" sub="de 8,544 cartera" />
        <KpiCard label="Tasa IA auto" value={<>72<span className="text-xl text-emerald-500">%</span></>} color="emerald" />
        <KpiCard label="Costo operativo hoy" value="$18.42" sub="$0.002/USD cobrado" />
      </div>

      {/* Canales */}
      <h2 className="font-display text-3xl font-semibold text-navy-700 mb-5">Canales</h2>
      <div className="grid grid-cols-2 gap-5">
        <Link
          to="/whatsapp"
          className="area-card"
          style={{ ['--accent' as string]: '#10b981' }}
        >
          <div className="flex items-start justify-between mb-5">
            <div className="w-14 h-14 bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-xl flex items-center justify-center shadow-inner">
              <MessageSquareText className="w-7 h-7 text-emerald-600" />
            </div>
            <span className="chip bg-emerald-50 text-emerald-700 flex items-center gap-1.5">
              <span className="pulse-live" />
              En vivo
            </span>
          </div>
          <h3 className="font-display text-2xl font-semibold text-navy-700">WhatsApp</h3>
          <p className="text-sm text-slate-600 mt-1">
            Campañas, autoservicio IA, gestión humana y revisión de comprobantes.
          </p>
          <div className="mt-4 flex items-center gap-1 text-xs text-emerald-600 font-medium">
            Ir a WhatsApp <ArrowRight className="w-3 h-3" />
          </div>
        </Link>

        <Link to="/voz" className="area-card" style={{ ['--accent' as string]: '#1c3c6b' }}>
          <div className="flex items-start justify-between mb-5">
            <div className="w-14 h-14 bg-gradient-to-br from-navy-50 to-navy-100 rounded-xl flex items-center justify-center shadow-inner">
              <PhoneCall className="w-7 h-7 text-navy-600" />
            </div>
            <span className="chip bg-slate-100 text-slate-600">Próximamente</span>
          </div>
          <h3 className="font-display text-2xl font-semibold text-navy-700">Agente de voz</h3>
          <p className="text-sm text-slate-600 mt-1">
            Camila Andrade — bot de llamadas con Retell AI para cobranza preventiva y mora.
          </p>
          <div className="mt-4 flex items-center gap-1 text-xs text-navy-600 font-medium">
            Ver detalle <ArrowRight className="w-3 h-3" />
          </div>
        </Link>
      </div>
    </div>
  )
}
